
export default class MemberChangeBackupPasswordRequestModel {
    public primaryPassword: string = '';
    public newBackupPassword: string = '';
    public currentBackupPassword: string = '';
}
